import {Component, OnInit} from '@angular/core';
import {HelperProvider} from '../providers/helper.provider';
import {Page} from '../model/page';
import {RestService} from '../providers/rest.service';
import {TalepTur} from '../model/talep-tur';
import {Router} from '@angular/router';

@Component({
  selector: 'app-talep-turler',
  templateUrl: './talep-turler.component.html',
  styleUrls: ['./talep-turler.component.css']
})
export class TalepTurlerComponent implements OnInit {
  talepTurler: TalepTur[] = null;

  constructor(private helperProvider: HelperProvider,
              private restService: RestService,
              private router: Router) {
  }

  ngOnInit(): void {
    this.helperProvider.currentPage$.next(Page.TalepTurler);

    this.getTalepTurler();
  }

  getTalepTurler() {
    this.restService.talepTurler().subscribe(res => {
      if (res != null) {
        this.talepTurler = res;
      }
    });
  }

  kaldir(s: TalepTur) {
    if (confirm(`${s.isim} talep türünü silmek istediğinize emin misiniz?`)) {
      this.restService.talepTurSil(s.id).subscribe(res => {
        if (res) {
          this.getTalepTurler();
        }
      });
    }
  }

  incele(s: TalepTur) {
    this.router.navigate(['talep-tur'], {queryParams: {id: s.id}});
  }

  new() {
    this.router.navigate(['talep-tur'], {queryParams: {id: '0'}});
  }
}
